const questionnaireApiPaths = {
  getPersonalSurvey: '/locations/questionnaires?locationName=personal-survey',
  getQuestionnaireAnswers: '/answers/users/self/questionnaires',
  postQuestionnaireAnswers: '/answers',
  postMigratePersonalSurveyLastAnswers: '/answers/actions/migratePersonalSurveyLastAnswers',
};

export default questionnaireApiPaths;
